import React from 'react';
import CountryToggler from './CountryToggler';
import {
  VIRGINIA_STATE_ID,
  WEST_VIRGINIA_STATE_ID,
  VIRGINIA_TRIBUTE_PHOTO_POSITION,
  WEST_VIRGINIA_TRIBUTE_PHOTO_POSITION,
  virginiaTributeToggleOverlay,
} from '../lib/virginiaTribute';
import {
  jurisdictionsForScope,
  regionDisplayNameById,
  useJurisdictionsCatalog,
} from '../lib/jurisdictionsCatalog';
export { regionDisplayNameById };

const TRIBUTE_PHOTOS = {
  [VIRGINIA_STATE_ID]: {
    url: `${process.env.PUBLIC_URL}/assets/virginia-tribute/virginia-combs.jpg`,
    position: VIRGINIA_TRIBUTE_PHOTO_POSITION,
  },
  [WEST_VIRGINIA_STATE_ID]: {
    url: `${process.env.PUBLIC_URL}/assets/virginia-tribute/virginia-combs-west.jpg`,
    position: WEST_VIRGINIA_TRIBUTE_PHOTO_POSITION,
  },
};

// onStateClick handles login logic and toggling
const StateToggleList = ({
  visitedStates,
  onStateClick,
  gameKey,
  mapType,
  playMode = 'monthly',
  stateTiers = {},
  virginiaTributeOn = false,
}) => {
  const { catalog } = useJurisdictionsCatalog();
  const states = jurisdictionsForScope(mapType, catalog);

  return (
    <div className="state-toggle-list">
      <CountryToggler currentMapType={mapType} />
      {mapType === 'COMBINED' && (
        <p className="state-toggle-list__hint">
          North America stats include all regions. Switch country to log Canada or Mexico plates.
        </p>
      )}
      <div className="state-grid">
        {states.map((state) => {
          const tier =
            playMode === 'monthly'
              ? visitedStates.includes(state.id)
                ? 'current_month'
                : 'none'
              : stateTiers[state.id] || 'none';
          const tierClass =
            playMode === 'monthly'
              ? tier === 'current_month'
                ? 'visited'
                : ''
              : tier === 'current_month'
                ? 'tier-green'
                : tier === 'window_only'
                  ? 'tier-orange'
                  : '';
          const showCheck = tier === 'current_month' || tier === 'window_only';
          const tributePhoto =
            virginiaTributeOn && (mapType === 'US' || mapType === 'COMBINED')
              ? TRIBUTE_PHOTOS[state.id]
              : null;
          const artStyle = tributePhoto
            ? {
                backgroundImage: `linear-gradient(${virginiaTributeToggleOverlay(tier, playMode)}, ${virginiaTributeToggleOverlay(tier, playMode)}), url(${tributePhoto.url})`,
                backgroundSize: 'cover',
                backgroundPosition: tributePhoto.position,
              }
            : undefined;
          return (
            <button
              key={state.id}
              type="button"
              className={`state-toggle-button ${tierClass}${tributePhoto ? ' state-toggle-button--virginia-tribute' : ''}`.trim()}
              style={artStyle}
              onClick={() => onStateClick(state.id)}
            >
              {showCheck && (
                <svg 
                  className="checkmark-icon" 
                  viewBox="0 0 24 24" 
                  width="16" 
                  height="16"
                >
                  <path 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    d="M2 12L9 19L22 6"
                  />
                </svg>
              )}
              {state.name}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default StateToggleList;
